import { render, staticRenderFns } from "./refMULocalTable.vue?vue&type=template&id=c6d4dade"
import script from "./refMULocalTable.vue?vue&type=script&lang=js"
export * from "./refMULocalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports